<template>
  <SideSheet :is-open="isCurtainOpen" :has-overlay="true">
    <div class="success-curtain" @click="opened">
      <div class="success-curtain-content" data-testid="success-curtain">
        <RoundedIcon
          icon-name="ic_check_simple"
          background-size="64"
          icon-size="36"
          :main-color="NebraskaColors.statusPositiveBackground"
          :text-color="NebraskaColors.statusPositive"
          aria-hidden="true"
        />

        <Heading
          data-cy="wallet-success-success"
          :level="2"
          class="success-curtain-title"
        >
          Resgate solicitado
        </Heading>
      </div>
    </div>
  </SideSheet>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { Heading, RoundedIcon } from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';

@Component({
  components: { Heading, RoundedIcon, SideSheet }
})
export default class SuccessCurtain extends Vue {
  @Prop({ type: Number, default: 1000 })
  public openDelay?: number;

  private isCurtainOpen = true;

  public get NebraskaColors() {
    return NebraskaColors;
  }

  private mounted() {
    setTimeout(this.opened, this.openDelay);
  }

  @Emit()
  private opened() {
    if (this.isCurtainOpen) this.isCurtainOpen = false;
  }
}
</script>

<style lang="less" scoped>
.success-curtain {
  height: 100vh;
  background-color: @status-positive;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-curtain-content {
  flex: 1;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: @size-spacing-x500;
}

.success-curtain-title {
  margin-top: @size-spacing-x400;
  color: @text-negative;
}
</style>
